<span [attr.data-automation]="'natural-language-editor-datepicker-' + phraseId()">
  <label
    [id]="'lbl-' + phraseId()"
    class="expression-keyword mb-0"
    [attr.for]="phraseId()"
    [ngClass]="{
      'expression-keyword--error': hasValidationError || externalHasValidationError(),
      'expression-keyword--empty': !entity,
    }"
    data-automation="natural-language-editor-datepicker-label"
  >
    @if (entity) {
      {{ entity | date: 'MM/dd/yy' }}
    } @else {
      {{ phraseId() }}
    }
  </label>

  <p-datepicker
    [attr.data-automation]="'natural-language-editor-datepicker-input'"
    [(ngModel)]="entity"
    (ngModelChange)="onUpdate($event)"
    [inputId]="phraseId()"
    [@.disabled]="true"
    [baseZIndex]="9999"
    [minDate]="minDate()"
    [selectOtherMonths]="true"
    [autofocus]="false"
    panelStyleClass="keyword-datepicker"
    inputStyleClass="keyword-datepicker-input"
  >
    <ng-template #disabledDateTooltipTemplate>
      <span [innerHTML]="disabledDateTooltipText() | escapeHtml"></span>
    </ng-template>

    <ng-template #date let-date>
      <span
        class="keyword-date"
        [class.keyword-date--blocked]="!date.selectable"
        [pTooltip]="disabledDateTooltipTemplate"
        [escape]="false"
        [tooltipDisabled]="date.selectable"
        tooltipPosition="top"
        tooltipStyleClass="keyword-datepicker-tooltip"
        appendTo="body"
      >
        {{ date.day }}
      </span>
    </ng-template>
  </p-datepicker>
</span>
